import { render, staticRenderFns } from "./FrameworkScoring.vue?vue&type=template&id=5f18e572"
import script from "./FrameworkScoring.vue?vue&type=script&lang=js"
export * from "./FrameworkScoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports